<template>
  <v-dialog v-model="propDialogo" width="500px" persistent>
    <v-card style="padding: 15px">
      <v-icon class="ma-1 right top" style="position: absolute" color="#0D47A1" large
        @click="clearFields(); $emit('closeDialogo')">mdi-close-circle</v-icon>
      <div style="text-align: center; justify-content: center">
        <div class="ml-4 mr-4">
          <h1 style="line-height: 1.2; color: black; text-align: center">
            {{ this.propNuevo ? "NUEVO" : "EDITAR" }} CURSO
          </h1>
        </div>
        <div style="padding-left: 10px; padding-right: 10px; margin: 10px">
          <div>
          </div>
        </div>
        <div class="line" style="padding: 10px; margin: 10px; border-radius: 5px">
          <!-- -------------------- -->
          <div>
            <h2>Imagen (alto: 800px; ancho: 400px)</h2>
            <div style="width: 100%; margin-bottom: 10px;">
              <input type="file" ref="fileInput" @change="handleImageUpload" accept="image/*" style="display: none" />
              <v-btn color="blue" style="color: white;" block @click="$refs.fileInput.click()">Buscar Imagen</v-btn>
              <div v-if="imagePreview">
                <div
                  style="margin-top: 10px; width: 100%; height: 150px; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center;">
                  <img :src="imagePreview" alt="Vista previa" style="max-width: 100%; max-height: 100%;" />
                </div>
                <h3>Imagen nueva</h3>
              </div>
              <div v-if="imagePreviewOld" style="width: 100%; margin-bottom: 10px;">
                <div
                  style="margin-top: 10px; width: 100%; height: 150px; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center;">
                  <img :src="`${$env.pathImg}/${imagePreviewOld}`" alt="Vista previa"
                    style="max-width: 100%; max-height: 100%;" />
                </div>
                <h3>Imagen actual</h3>
              </div>
            </div>
            <div>
              <h2>Título</h2>
              <v-text-field v-model="formulario.titulo" outlined dense placeholder="Ingrese título" />
            </div>
            <div>
              <h2>Contenido</h2>
              <v-textarea v-model="formulario.detalles" placeholder="Ingrese contenido" outlined no-resize />
            </div>
            <v-row>
              <v-col lg="4" cols="4" class="ma-0 pa-2">
                <div>
                  <h2>Modalidad</h2>
                  <v-text-field v-model="formulario.modalidad" outlined dense placeholder="Ingrese título" />
                </div>
              </v-col>
              <v-col lg="4" cols="4" class="ma-0 pa-2">
                <div>
                  <h2>Duración</h2>
                  <v-text-field v-model="formulario.duracion" outlined dense placeholder="Ingrese título" />
                </div>
              </v-col>
              <v-col lg="4" cols="4" class="ma-0 pa-2">
                <div>
                  <h2>Inicio</h2>
                  <v-text-field v-model="formulario.fecha_inicio" outlined dense placeholder="Ingrese título" />
                </div>
              </v-col>
            </v-row>
              <div>
              <h2>Enlace</h2>
              <v-text-field v-model="formulario.enlace" outlined dense placeholder="Ingrese título" />
            </div>
            <v-btn block color="#0D47A1" style="color: white" @click="propNuevo ? crearCurso() : actualizarCurso()">
              <h2>GUARDAR</h2>
            </v-btn>
          </div>
          <!-- -------------------- -->
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    propCrear: { type: Function },
    propActualizar: { type: Function },
    propNuevo: { type: Boolean },
    propDialogo: { type: Boolean },
    propCurso: { type: Object }
  },
  data() {
    return {
      formulario: {
        id: '',
        titulo: '',
        detalles: '',
        imagen: null,
        modalidad: '',
        duracion: '',
        fecha_inicio: '',
        enlace: '',
      },
      imagePreview: null,
      imagePreviewOld: null,
      sms: "",
      preDepartment: "",
      preResponsible: "",
      days: Array.from({ length: 31 }, (_, i) =>
        String(i + 1).padStart(2, "0")
      ),
      months: Array.from({ length: 12 }, (_, i) =>
        String(i + 1).padStart(2, "0")
      ),
      years: Array.from({ length: 7 }, (_, i) => String(2024 + i)),
      hours: Array.from({ length: 24 }, (_, i) => String(i).padStart(2, "0")),
      minutes: Array.from({ length: 60 }, (_, i) => String(i).padStart(2, "0")),
    };
  },
  mounted() { },
  watch: {
    propCurso() {
      this.clearFields()
      this.setFields()
    }
  },
  methods: {
    handleImageUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.formulario.imagen = file;
        this.imagePreview = URL.createObjectURL(file);
      }
    },

    async crearCurso() {
      if (!this.formulario.titulo || !this.formulario.detalles || !this.formulario.imagen) {
        this.sms = "Faltan campos por llenar";
        return;
      }
      const form = new FormData();
      form.append("titulo", this.formulario.titulo);
      form.append("detalles", this.formulario.detalles);
      form.append("imagen", this.formulario.imagen);
      form.append("modalidad", this.formulario.modalidad);
      form.append("duracion", this.formulario.duracion);
      form.append("fecha_inicio", this.formulario.fecha_inicio);
      form.append("enlace", this.formulario.enlace);
      try {
        const result = await this.propCrear(form); // Enviamos como formulario
        const _result = result.data
        if (_result.status === "success") {
          this.clearFields()
          this.$emit("closeDialogo");
        } else {
          this.sms = "Error al registrar. Intente nuevamente.";
        }
      } catch (error) {
        console.error(error);
        this.sms = "Error inesperado.";
      }
    },
    async actualizarCurso() {
      if (!this.formulario.titulo || !this.formulario.detalles || !this.formulario.imagen) {
        this.sms = "Faltan campos por llenar";
        return;
      }
      const form = new FormData();
      form.append("id", this.formulario.id);
      form.append("titulo", this.formulario.titulo);
      form.append("detalles", this.formulario.detalles);
      form.append("imagen", this.formulario.imagen);
      form.append("modalidad", this.formulario.modalidad);
      form.append("duracion", this.formulario.duracion);
      form.append("fecha_inicio", this.formulario.fecha_inicio);
      form.append("enlace", this.formulario.enlace);
      try {
        const result = await this.propActualizar(form); // Enviamos como formulario
        if (result.status === "success") {
          this.clearFields()
          this.$emit("closeDialogo");
        } else {
          this.sms = "Error al registrar. Intente nuevamente.";
        }
        
      } catch (error) {
        console.error(error);
        this.sms = "Error inesperado.";
      }
    },
    splitDateTime(dateTime) {
      const [date, time] = dateTime.split(", "); // Divide en fecha y hora
      const [year, month, day] = date.split("/"); // Divide la fecha en partes
      const [hour, minute, second] = time.split(":"); // Divide la hora en partes

      return {
        year,
        month,
        day,
        hour,
        minute,
        second,
      };
    },
    setFields() {
      this.formulario.id = this.propCurso.id
      this.formulario.titulo = this.propCurso.titulo
      this.formulario.detalles = this.propCurso.detalles
      this.formulario.imagen = this.propCurso.imagen_ruta
      this.formulario.modalidad = this.propCurso.modalidad
      this.formulario.duracion = this.propCurso.duracion
      this.formulario.fecha_inicio = this.propCurso.fecha_inicio
      this.formulario.enlace = this.propCurso.enlace
      this.imagePreviewOld = this.propCurso.imagen_ruta
    },
    clearFields() {
      this.formulario.titulo = ''
      this.formulario.detalles = ''
      this.formulario.imagen = null
      this.formulario.id = ''
      this.formulario.modalidad = ''
      this.formulario.duracion = ''
      this.formulario.fecha_inicio = ''
      this.formulario.enlace = ''
      this.imagePreview = null
      this.imagePreviewOld = null
    },
    genDate() {
      const options = {
        timeZone: "America/Guayaquil", // Configura la zona horaria de Guayaquil
        hour12: false, // Usar formato de 24 horas
      };

      const now = new Date();

      // Usar toLocaleString para obtener la fecha en la zona horaria especificada
      const year = now.toLocaleString("es-EC", { ...options, year: "numeric" });
      const month = String(
        now.toLocaleString("es-EC", { ...options, month: "2-digit" })
      ).padStart(2, "0");
      const day = String(
        now.toLocaleString("es-EC", { ...options, day: "2-digit" })
      ).padStart(2, "0");
      const hours = String(
        now.toLocaleString("es-EC", { ...options, hour: "2-digit" })
      ).padStart(2, "0");
      const minutes = String(
        now.toLocaleString("es-EC", { ...options, minute: "2-digit" })
      ).padStart(2, "0");
      const seconds = String(
        now.toLocaleString("es-EC", { ...options, second: "2-digit" })
      ).padStart(2, "0");
      return `${year}/${month}/${day}, ${hours}:${minutes}:${seconds}`;
    },
  },
};
</script>
<style scoped></style>
